/*
 * AMASS reveal-on-scroll (US-009)
 * ----------------------------------------------------------------------------
 * Subtle, non-jacking reveal: elements tagged [data-amass-reveal] fade + rise
 * a few pixels into place the first time they scroll into view. NO scroll
 * pinning, NO scroll hijacking — the page scrolls natively; this only toggles a
 * class as elements cross the viewport (IntersectionObserver, one-shot).
 *
 * Motion is fully gated on prefers-reduced-motion: if the user prefers reduced
 * motion (or IntersectionObserver is unavailable, or JS fails), every element
 * is shown immediately with no transform — content is never hidden by JS alone
 * (the CSS only dims when .amass-reveal-ready is on <html>, set below, so a
 * no-JS / failed-JS visitor always sees everything).
 */
(function () {
  'use strict';

  var root = document.documentElement;

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // No motion path: never arm the hidden state; bail out entirely.
  if (prefersReduced || !('IntersectionObserver' in window)) {
    return;
  }

  // Arm: tells CSS it's safe to start elements in the pre-reveal (dim) state.
  root.classList.add('amass-reveal-ready');

  function revealAll() {
    var els = document.querySelectorAll('[data-amass-reveal]');
    for (var i = 0; i < els.length; i++) {
      els[i].classList.add('is-revealed');
    }
  }

  function init() {
    var els = document.querySelectorAll('[data-amass-reveal]:not(.is-revealed)');
    if (!els.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    els.forEach(function (el) {
      // Optional stagger via data-amass-reveal-delay (ms).
      var d = el.getAttribute('data-amass-reveal-delay');
      if (d) el.style.setProperty('--amass-reveal-delay', d + 'ms');
      io.observe(el);
    });

    // Safety net: anything still hidden after 3s (e.g. observer edge cases) is shown.
    window.setTimeout(revealAll, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-scan when a section is re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
